import { PageType } from '@hotelplan/graphql.types';

export const MY_ACCOUNT_PAGES: Array<PageType> = [
  PageType.MyaccountMybookings,
  PageType.MyaccountBookingDetails,
  PageType.Wishlist,
  PageType.MyaccountMyprofile,
];
